// Traduction française pour le module Temps
export const locale = {
  lang: 'fr',
  data: {
    TEMPS: {
      ALL_ENTRIES_ALREADY_EXIST: 'Les horaires indiqués ont déjà été déclarés pour cet utilisateur à ces dates',
      SOME_ENTRIES_ALREADY_EXIST: 'Certains horaires ont été ignorés car ils étaient déjà déclarés',
      TIME_ALREADY_EXISTS: 'Cet horaire existe déjà pour cet utilisateur à cette date',
      FORFAIT_JOURS_SINGLE_DECLARATION: 'Déclaration pour ce jour déjà existe',
      MODAL_SUBTITLE: 'Déclarez vos heures de travail',
      EDIT_MODAL_SUBTITLE: 'Modifiez les détails de votre déclaration',
      EDIT_DECLARATION: 'Modifier la déclaration',
      EDIT_SUCCESS: 'Déclaration modifiée avec succès',
      HORAIRES: 'Horaires',
      DESCRIPTION_PLACEHOLDER: 'Décrivez le travail effectué...',
      PROJET: 'Projet',
      SELECT_PROJECT: 'Sélectionner un projet...',
      AUCUN: 'Aucun',
      HOURS: 'heures',
      HOUR: 'heure',
      MINUTES: 'minutes',
      MINUTE: 'minute',
      AND: 'et',
      PERIODE: 'Période',
      JOURNEE_ENTIERE: 'Journée entière',
      MATINEE: 'Matinée',
      APRESMIDI: 'Après-midi',
      ALERT_MODAL_SUBTITLE: 'Signalez un problème ou une situation nécessitant une attention particulière',
      COMMENTAIRE: 'Commentaire',
      ALERT_COMMENT_PLACEHOLDER: 'Décrivez le problème ou la situation...',
      ENVOYER_ALERTE: 'Envoyer l\'alerte',
      ALERT_ENVOYEE_SUCCESS: 'Alerte envoyée avec succès',
      DECLARE_ALERT: 'Déclarer une alerte',
      ALERT_MESSAGE: 'Message d\'alerte',
      ALERT_MESSAGE_PLACEHOLDER: 'Écrivez votre message d\'alerte ici...',
      ALERT_MESSAGE_REQUIRED: 'Le message d\'alerte est requis',
      ALERT_SAVED_SUCCESS: 'Alerte enregistrée avec succès',
      VALIDER_SEMAINE: 'Valider toute la semaine',
      SEMAINE_DU: 'Semaine du',
      AU: 'au',
      CONFIRM_VALIDER_SEMAINE: 'Voulez-vous valider toutes les journées en attente de cette semaine ?',
      VALIDATION_SEMAINE_SUCCESS: 'Semaine validée avec succès',
      DECLARER_SEMAINE: 'Déclarer une semaine',
      DECLARE_WEEK_TITLE: 'Déclarer une semaine',
      DECLARE_WEEK_SUBTITLE: 'Déclarez une semaine entière en quelques clics',
      DELEGATED_MANUAL_TEMPLATE: 'Déclaration pour un seul collaborateur avec un gabarit manuel. Les horaires habituels ne sont pas chargés et les jours déjà déclarés sont conservés.',
      DELEGATED_LOAD_ERROR: 'Chargement impossible. La déclaration reste bloquée. Sélectionnez à nouveau le collaborateur pour réessayer.',
      DELEGATED_CALENDAR_UNAVAILABLE: 'Le calendrier des congés de ce collaborateur est indisponible dans votre périmètre autorisé. La déclaration est bloquée.',
      DELEGATED_INVALID_PERIOD: 'Veuillez renseigner une période valide avec une fin égale ou postérieure au début.',
      DELEGATED_INVALID_HOURS: 'Terminez les modifications et vérifiez les horaires : début avant fin, pause complète et strictement comprise dans la journée.',
      SEMAINE_DE_REFERENCE: 'Semaine contenant le',
      JOURS_A_DECLARER: 'Jours à déclarer',
      AUCUN_JOUR_SELECTIONNE: 'Veuillez sélectionner au moins un jour',
      JOURS_DECLARES_SUCCESS: 'jour(s) déclaré(s) avec succès',
      JOURS_DECLARATION_ECHEC: 'jour(s) déjà déclaré(s) ou en erreur',
      SELECTIONNER_PERIODE: 'Sélectionner une période',
      HORAIRES_PAR_DEFAUT: 'Horaires par défaut',
      HORAIRES_PAR_DEFAUT_SUBTITLE: 'Appliquez les mêmes horaires aux jours sélectionnés',
      DEBUT_JOURNEE: 'Début de journée',
      DEBUT_PAUSE: 'Début pause',
      FIN_PAUSE: 'Fin pause',
      FIN_JOURNEE: 'Fin de journée',
      APPLIQUER_A: 'Appliquer à',
      APPLIQUE_A_JOURS: 'Appliqué à {{count}} jours',
      REINITIALISER: 'Réinitialiser',
      COPIER_SUR_LA_SEMAINE: 'Copier sur la semaine',
      APERCU_SEMAINE: 'Aperçu de la semaine',
      JOUR: 'Jour',
      STATUT: 'Statut',
      HORAIRES_DE_TRAVAIL: 'Horaires de travail',
      PAUSE: 'Pause',
      TOTAL: 'Total',
      ACTION: 'Action',
      STATUT_PAR_DEFAUT: 'Par défaut',
      STATUT_MODIFIE: 'Modifié',
      STATUT_TELETRAVAIL: 'Télétravail',
      STATUT_NON_TRAVAILLE: 'Non travaillé',
      STATUT_DEJA_DECLARE: 'Déjà déclaré',
      STATUT_VALIDE: 'Validé',
      STATUT_CONGE: 'Congé',
      JOUR_TRAVAILLE: 'Jour travaillé',
      ENREGISTRER: 'Enregistrer',
      TOTAL_SEMAINE: 'Total semaine',
      SUR_N_JOURS: 'sur {{count}} jours',
      DECLARER_LA_SEMAINE_BTN: 'Déclarer la semaine',
      VALIDER_UNE_SEMAINE: 'Valider une semaine',
      VALIDATE_WEEK_TITLE: 'Valider une semaine',
      VALIDATE_WEEK_SUBTITLE: 'Validez rapidement les temps saisis par vos collaborateurs',
      COLLABORATEURS: 'Collaborateurs',
      HEURES_A_VALIDER: 'Heures à valider',
      JOURS_A_VALIDER: 'Jours à valider',
      ALERTES_CONTRAT: 'Alertes contrat',
      TOUS_LES_COLLABORATEURS: 'Tous les collaborateurs',
      AFFICHER_ALERTES_UNIQUEMENT: 'Afficher uniquement les alertes',
      COLLABORATEUR: 'Collaborateur',
      CONTRAT_HEBDO: 'Contrat (hebdo)',
      FORFAIT_JOURS_LABEL: 'Forfait jours',
      A_VALIDER_CETTE_SEMAINE: 'À valider (cette semaine)',
      CONFORME: 'Conforme',
      DEPASSEMENT: 'Dépassement',
      ALERTES_INFO_CONTRAT: 'Les alertes indiquent que les heures saisies sont supérieures au nombre d\'heures hebdomadaires défini dans le contrat.',
      TOUT_VALIDER: 'Tout valider',
      VALIDER_LA_SELECTION: 'Valider la sélection',
      AUCUNE_DONNEE_A_VALIDER: 'Aucune heure à valider pour cette période',
      AUCUN_COLLABORATEUR_SELECTIONNE: 'Veuillez sélectionner au moins un collaborateur',
    },
    ALERTES: {
      LOADING_ALERTS: 'Chargement des alertes...',
      PLEASE_WAIT: 'Veuillez patienter',
      NO_ALERTS: 'Aucune alerte',
      SENDER: 'Expéditeur',
      RECIPIENT: 'Destinataire',
      PERSON: 'Personne',
      DIRECTION: 'Sens',
      DIRECTION_SENT: 'Sortant',
      DIRECTION_RECEIVED: 'Entrante',
      ADMIN_DIRECTION_SENT: 'Envoyé',
      ADMIN_DIRECTION_RECEIVED: 'Reçu',
      MESSAGE: 'Message',
      DATE: 'Date',
      EMISSION_DATE: 'Date d\'émission',
      READ_DATE: 'Lu le',
      PROCESSED_DATE: 'Traité le',
      STATUS: 'Statut',
      STATUS_UNREAD: 'Non lu',
      STATUS_READ: 'Lu',
      STATUS_PROCESSED: 'Traité',
      MARK_AS_READ: 'Marquer comme lu',
      MARK_AS_PROCESSED: 'Marquer comme traité',
      VIEW_ALERT: 'Voir l\'alerte',
      ALERT_DETAILS: 'Détails de l\'alerte',
      FROM: 'De',
      FULL_MESSAGE: 'Message complet',
      DISCLAIMER: 'Attention EmyeHR fourni certaines alertes, qui sont à titre indicatif, ne sont pas exaustives, et n\'engagent pas la responsabilité de l\'éditeur.',
      LEGAL_NOTICE_LINK: 'Mentions légales — Suivi du temps',
      LEGAL_NOTICE_TITLE: 'Portée des alertes et responsabilité',
      LEGAL_NOTICE_SCOPE: 'Les alertes disponibles dans ce module sont fournies à titre purement indicatif et ne constituent pas une liste exhaustive de l\'ensemble des obligations légales, conventionnelles ou réglementaires applicables en matière de temps de travail.',
      LEGAL_NOTICE_EXHAUSTIVENESS: 'Absence de garantie d\'exhaustivité',
      LEGAL_NOTICE_EXHAUSTIVENESS_TEXT: 'Le système d\'alertes ne couvre pas nécessairement l\'ensemble des règles issues du Code du travail, des conventions collectives applicables, des accords d\'entreprise ou de tout autre dispositif particulier propre à l\'entreprise utilisatrice. Des situations non détectées par les alertes peuvent néanmoins constituer des manquements aux règles en vigueur.',
      LEGAL_NOTICE_RESPONSIBILITY: 'Responsabilité de l\'entreprise utilisatrice',
      LEGAL_NOTICE_RESPONSIBILITY_TEXT: 'Il appartient à l\'entreprise utilisatrice de s\'assurer, sous sa propre responsabilité, du respect de l\'ensemble des dispositions légales et conventionnelles applicables à ses salariés. L\'éditeur de la solution ne saurait être tenu responsable de tout manquement résultant de l\'absence de déclenchement d\'une alerte ou d\'une alerte incomplète.',
      LEGAL_NOTICE_RECOMMENDATION: 'Recommandation',
      LEGAL_NOTICE_RECOMMENDATION_TEXT: 'Nous recommandons à l\'entreprise utilisatrice de compléter le suivi automatisé par ses propres contrôles internes et, le cas échéant, de consulter un conseil juridique spécialisé en droit social pour toute question relative à la conformité de ses pratiques de gestion du temps de travail.',
      LEGAL_NOTICE_FOOTER: 'Les alertes fournies sont indicatives et non exhaustives. La conformité réglementaire relève de la seule responsabilité de l\'entreprise utilisatrice.',
      CLOSE: 'Fermer',
    }
  }
}

// Exporter les traductions
export default locale.data;
